
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function SpecialistCollaboration() {
  const [selectedSpecialty, setSelectedSpecialty] = useState('psychiatry');
  const [showReferralForm, setShowReferralForm] = useState(false);

  const specialties = [
    {
      id: 'psychiatry',
      name: '精神科',
      icon: 'ri-brain-line',
      description: 'うつ病、不安障害、統合失調症などの精神疾患'
    },
    {
      id: 'psychosomatic',
      name: '心療内科',
      icon: 'ri-heart-pulse-line',
      description: 'ストレス関連疾患、心身症'
    },
    {
      id: 'psychology',
      name: '臨床心理士',
      icon: 'ri-user-heart-line',
      description: 'カウンセリング、心理療法'
    },
    {
      id: 'sleep',
      name: '睡眠専門医',
      icon: 'ri-moon-line',
      description: '睡眠障害、不眠症'
    }
  ];

  const referralCriteria = {
    psychiatry: [
      '持続的な気分の落ち込み（2週間以上）',
      '強い不安や恐怖感',
      '幻覚や妄想の症状',
      '自傷行為や自殺念慮',
      '日常生活に著しい支障',
      '薬物療法が必要と判断される場合'
    ],
    psychosomatic: [
      'ストレスによる身体症状',
      '原因不明の身体的不調',
      '心身の相互作用が疑われる症状',
      '生活習慣病とストレスの関連',
      '職場や家庭でのストレス問題',
      '身体疾患に伴う心理的問題'
    ],
    psychology: [
      '話を聞いてもらいたい',
      '認知行動療法を希望',
      '対人関係の悩み',
      'トラウマの処理',
      '性格や行動パターンの改善',
      '薬物療法以外の治療を希望'
    ],
    sleep: [
      '慢性的な不眠症状',
      '睡眠時無呼吸症候群の疑い',
      '過眠症状',
      '概日リズム睡眠障害',
      'レストレスレッグス症候群',
      '睡眠時随伴症状'
    ]
  };

  const collaborationProcess = [
    {
      step: 1,
      title: '初回相談',
      description: '薬剤師による症状の聞き取りと評価',
      duration: '30分',
      icon: 'ri-chat-3-line'
    },
    {
      step: 2,
      title: '専門医選定',
      description: '症状に応じた適切な専門医の選定',
      duration: '即日',
      icon: 'ri-user-search-line'
    },
    {
      step: 3,
      title: '紹介状作成',
      description: '詳細な症状と経過の紹介状作成',
      duration: '1-2日',
      icon: 'ri-file-text-line'
    },
    {
      step: 4,
      title: '予約調整',
      description: '専門医への予約取得サポート',
      duration: '1-7日',
      icon: 'ri-calendar-check-line'
    },
    {
      step: 5,
      title: '継続フォロー',
      description: '治療経過の確認と薬剤管理',
      duration: '継続',
      icon: 'ri-heart-line'
    }
  ];

  const supportServices = [
    {
      title: '緊急時対応',
      description: '24時間対応の緊急相談窓口',
      icon: 'ri-alarm-warning-line',
      color: 'red'
    },
    {
      title: '家族サポート',
      description: 'ご家族への説明と支援',
      icon: 'ri-group-line',
      color: 'blue'
    },
    {
      title: '薬剤管理',
      description: '精神科薬物の適切な管理',
      icon: 'ri-medicine-bottle-line',
      color: 'green'
    },
    {
      title: '社会復帰支援',
      description: '職場復帰や社会参加のサポート',
      icon: 'ri-building-line',
      color: 'purple'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center">
                <div className="w-10 h-10 mr-3 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-lg transform rotate-12 shadow-lg"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-lg"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-600" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </Link>
            </div>
            <nav className="hidden md:flex space-x-8">
              <Link to="/services" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">サービス</Link>
              <Link to="/health-support" className="text-teal-600 hover:text-teal-700 font-medium whitespace-nowrap cursor-pointer">健康サポート</Link>
              <Link to="/pharmacist-resources" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">薬剤師向け</Link>
              <Link to="/information" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">情報提供</Link>
            </nav>
            <button className="md:hidden p-2">
              <i className="ri-menu-line text-xl"></i>
            </button>
          </div>
        </div>
      </header>

      {/* Breadcrumb */}
      <div className="bg-gray-50 py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex" aria-label="Breadcrumb">
            <ol className="flex items-center space-x-4">
              <li>
                <Link to="/" className="text-gray-500 hover:text-gray-700 cursor-pointer">ホーム</Link>
              </li>
              <li>
                <i className="ri-arrow-right-s-line text-gray-400"></i>
              </li>
              <li>
                <Link to="/health-support" className="text-gray-500 hover:text-gray-700 cursor-pointer">健康サポート</Link>
              </li>
              <li>
                <i className="ri-arrow-right-s-line text-gray-400"></i>
              </li>
              <li className="text-gray-900 font-medium">専門医連携</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-teal-50 to-blue-50 py-16">
        <div className="absolute inset-0">
          <img 
            src="https://public.readdy.ai/ai/img_res/302a57f34be25a14c5562a7bd6a8cc7d.jpg"
            alt="専門医連携"
            className="w-full h-full object-cover object-top opacity-20"
          />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            専門医<span className="text-teal-600">連携</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            必要に応じて精神科医、心療内科医、臨床心理士との連携をサポートし、最適な治療につなげます
          </p>
        </div>
      </section>

      {/* Specialty Selection */}
      <section className="py-8 bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-4">
            {specialties.map((specialty) => (
              <button
                key={specialty.id}
                onClick={() => setSelectedSpecialty(specialty.id)}
                className={`p-4 rounded-xl text-center transition-all cursor-pointer ${
                  selectedSpecialty === specialty.id
                    ? 'bg-teal-600 text-white shadow-lg'
                    : 'bg-gray-100 text-gray-700 hover:bg-teal-50 hover:text-teal-600'
                }`}
              >
                <i className={`${specialty.icon} text-2xl mb-2 block`}></i>
                <div className="font-bold mb-1">{specialty.name}</div>
                <div className="text-sm opacity-90">{specialty.description}</div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Referral Criteria */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-6">
                {specialties.find(s => s.id === selectedSpecialty)?.name}への紹介基準
              </h2>
              <div className="bg-white rounded-xl shadow-lg p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-4">以下の症状がある場合は専門医への相談をお勧めします</h3>
                <ul className="space-y-3">
                  {referralCriteria[selectedSpecialty as keyof typeof referralCriteria]?.map((criteria, index) => (
                    <li key={index} className="flex items-start">
                      <i className="ri-check-line text-teal-600 mr-3 mt-0.5 flex-shrink-0"></i>
                      <span className="text-gray-700">{criteria}</span>
                    </li>
                  ))}
                </ul>
                <div className="mt-6 p-4 bg-yellow-50 rounded-lg border border-yellow-200">
                  <div className="flex items-start">
                    <i className="ri-information-line text-yellow-600 mr-2 mt-0.5"></i>
                    <div className="text-sm text-yellow-800">
                      <strong>重要：</strong>自殺念慮や自傷行為がある場合は、緊急性が高いため即座に専門医への受診が必要です。
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Collaboration Process */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-6">連携プロセス</h2>
              <div className="space-y-4">
                {collaborationProcess.map((process, index) => (
                  <div key={index} className="bg-white rounded-xl shadow-lg p-6">
                    <div className="flex items-start">
                      <div className="w-12 h-12 bg-teal-100 text-teal-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                        <i className={process.icon}></i>
                      </div>
                      <div className="flex-1">
                        <div className="flex items-center justify-between mb-2">
                          <h3 className="text-lg font-bold text-gray-900">
                            ステップ{process.step}: {process.title}
                          </h3>
                          <span className="text-sm text-gray-500 bg-gray-100 px-2 py-1 rounded-full">
                            {process.duration}
                          </span>
                        </div>
                        <p className="text-gray-600">{process.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Support Services */}
          <div className="mt-16">
            <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center">追加サポートサービス</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {supportServices.map((service, index) => (
                <div key={index} className="bg-white rounded-xl shadow-lg p-6 text-center">
                  <div className={`w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center ${
                    service.color === 'red' ? 'bg-red-100 text-red-600' :
                    service.color === 'blue' ? 'bg-blue-100 text-blue-600' :
                    service.color === 'green' ? 'bg-green-100 text-green-600' :
                    'bg-purple-100 text-purple-600'
                  }`}>
                    <i className={`${service.icon} text-2xl`}></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{service.title}</h3>
                  <p className="text-gray-600 text-sm">{service.description}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Emergency Contact */}
          <div className="mt-16 bg-red-50 rounded-xl p-8 border border-red-200">
            <div className="text-center">
              <div className="w-16 h-16 bg-red-100 text-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-alarm-warning-line text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">緊急時の対応</h3>
              <p className="text-gray-700 mb-6">
                自殺念慮、自傷行為、重篤な精神症状がある場合は、以下の緊急連絡先にご連絡ください。
              </p>
              <div className="grid md:grid-cols-3 gap-4 text-sm">
                <div className="bg-white rounded-lg p-4">
                  <div className="font-bold text-gray-900 mb-1">いのちの電話</div>
                  <div className="text-red-600 font-bold">0570-783-556</div>
                  <div className="text-gray-600">24時間対応</div>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <div className="font-bold text-gray-900 mb-1">救急車</div>
                  <div className="text-red-600 font-bold">119</div>
                  <div className="text-gray-600">生命に危険がある場合</div>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <div className="font-bold text-gray-900 mb-1">精神科救急</div>
                  <div className="text-red-600 font-bold">地域により異なる</div>
                  <div className="text-gray-600">各都道府県の窓口</div>
                </div>
              </div>
            </div>
          </div>

          {/* Referral Form */}
          <div className="mt-16 text-center">
            <button
              onClick={() => setShowReferralForm(!showReferralForm)}
              className="bg-teal-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-teal-700 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-user-add-line mr-2"></i>
              専門医紹介を依頼する
            </button>
          </div>

          {showReferralForm && (
            <div className="mt-8 max-w-2xl mx-auto bg-white rounded-xl shadow-lg p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">専門医紹介依頼フォーム</h3>
              <form className="space-y-6">
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">お名前</label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-teal-500 focus:border-teal-500"
                      placeholder="山田太郎"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">年齢</label>
                    <input
                      type="number"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-teal-500 focus:border-teal-500"
                      placeholder="30"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">希望する専門科</label>
                  <select className="w-full px-3 py-2 pr-8 border border-gray-300 rounded-lg focus:ring-teal-500 focus:border-teal-500">
                    <option value="">選択してください</option>
                    <option value="psychiatry">精神科</option>
                    <option value="psychosomatic">心療内科</option>
                    <option value="psychology">臨床心理士</option>
                    <option value="sleep">睡眠専門医</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">症状・相談内容</label>
                  <textarea
                    rows={4}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-teal-500 focus:border-teal-500"
                    placeholder="現在の症状や困っていることを詳しくお書きください"
                  ></textarea>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">連絡先電話番号</label>
                  <input
                    type="tel"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-teal-500 focus:border-teal-500"
                    placeholder="090-1234-5678"
                  />
                </div>
                <div className="text-center">
                  <button
                    type="submit"
                    className="bg-teal-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-teal-700 whitespace-nowrap cursor-pointer"
                  >
                    紹介依頼を送信
                  </button>
                </div>
              </form>
            </div>
          )}

          {/* Related Services */}
          <div className="mt-16 bg-gray-50 rounded-xl p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">関連サービス</h3>
            <div className="grid md:grid-cols-3 gap-6">
              <Link to="/mental-health/stress-assessment" className="bg-white rounded-lg p-6 hover:shadow-lg transition-shadow cursor-pointer">
                <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-emotion-line text-xl"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-2">ストレス評価</h4>
                <p className="text-gray-600 text-sm">専門医受診前の状態評価</p>
              </Link>
              <Link to="/mental-health/relaxation-guidance" className="bg-white rounded-lg p-6 hover:shadow-lg transition-shadow cursor-pointer">
                <div className="w-12 h-12 bg-green-100 text-green-600 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-leaf-line text-xl"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-2">リラクゼーション指導</h4>
                <p className="text-gray-600 text-sm">治療と併用できるセルフケア</p>
              </Link>
              <Link to="/mental-health/sleep-improvement-support" className="bg-white rounded-lg p-6 hover:shadow-lg transition-shadow cursor-pointer">
                <div className="w-12 h-12 bg-purple-100 text-purple-600 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-moon-line text-xl"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-2">睡眠改善サポート</h4>
                <p className="text-gray-600 text-sm">睡眠の質向上による症状改善</p>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center mb-4">
                <div className="w-8 h-8 mr-2 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg transform rotate-12"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-300 to-emerald-300 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-sm"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-400" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </div>
              <p className="text-gray-400">
                患者さんと薬剤師をつなぐ総合医療情報プラットフォーム
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">メンタルヘルス</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/mental-health/stress-assessment" className="hover:text-white cursor-pointer">ストレス評価</Link></li>
                <li><Link to="/mental-health/relaxation-guidance" className="hover:text-white cursor-pointer">リラクゼーション指導</Link></li>
                <li><Link to="/mental-health/sleep-improvement-support" className="hover:text-white cursor-pointer">睡眠改善サポート</Link></li>
                <li><Link to="/mental-health/specialist-collaboration" className="hover:text-white cursor-pointer">専門医連携</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">健康サポート</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/health-support" className="hover:text-white cursor-pointer">健康相談</Link></li>
                <li><Link to="/health-support" className="hover:text-white cursor-pointer">サルコペニア予防</Link></li>
                <li><Link to="/health-support" className="hover:text-white cursor-pointer">フレイル対策</Link></li>
                <li><Link to="/health-support" className="hover:text-white cursor-pointer">栄養指導</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">情報・リンク</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/information" className="hover:text-white cursor-pointer">公的機関リンク</Link></li>
                <li><Link to="/career" className="hover:text-white cursor-pointer">転職情報</Link></li>
                <li><Link to="/entertainment" className="hover:text-white cursor-pointer">エンタメ</Link></li>
                <li><Link to="/beast-blog" className="hover:text-white cursor-pointer">ビースト君ブログ</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 みんなの薬局～Pharmacare～. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white cursor-pointer">Website Builder</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
